export const pageVariants = {
    initial: (isGoingToCover)=>({
            x: isGoingToCover ? '-50%' : '50%',
            opacity: 0,
            transition: {
                x: {
                    type: 'tween',
                    duration: 0.6,
                    ease: 'easeInOut'
                },
                opacity: {
                    duration: 0.6,
                    ease: 'easeInOut'
                }
            }
        }),
    animate: {
        x: 0,
        opacity: 1
    },
    exit: (isGoingToCover)=>({
            x: isGoingToCover ? '50%' : '-50%',
            opacity: 0,
            transition: {
                x: {
                    type: 'tween',
                    duration: 0.4,
                    ease: 'easeInOut'
                },
                opacity: {
                    duration: 0.4,
                    ease: 'easeInOut'
                }
            }
        })
};
export const pageTransition = {
    x: {
        type: 'tween',
        duration: 0.4,
        ease: 'easeInOut'
    },
    opacity: {
        duration: 0.4
    }
};
export const animatePresenceVariants = {
    initial: 'initial',
    animate: 'animate',
    exit: 'exit'
};
